export default __webpack_public_path__ + "static/media/whatsapp_banner_headline_mobile_new.28e9db64.gif";